import { firestore } from '../../firebase.config';
import { createConsentService } from './consentCore';

const consentService = createConsentService(firestore, {
  userCollection: 'UserProfileMaster',
});

export const {
  getLegalSettings,
  saveLegalSettings,
  checkTncVersionMatch,
  recordConsent,
  recordLogin,
  getConsentHistory,
  requestAccountDeletion,
  getClientLocation,
} = consentService;
